<template>
  <custom-dialog width="500px" :title="model.title" :visible="visible" v-on="$listeners">
    <div class="dialog-body">
      <!-- 用户信息 -->
      <el-form :model="form" :rules="rules" ref="form">
        <el-row>
          <el-col :span="24">
            <el-form-item :label="$t('base_languageKey_param_dialog.suo_shu_ying_yong')" prop="appId">
              <el-select v-model="appName" disabled :placeholder="$t('Common.com_please_select')"></el-select>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item :label="$t('base_languageKey_param_dialog.jian_lei_xing')" prop="langKeyType">
              <custom-select v-model="form.langKeyType" :disabled="model.type === 'edit' || model.data.langKeyTypeOn" code="bas_lang_key_type" :placeholder="$t('Common.com_please_select')"></custom-select>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item v-if="model.type === 'add'" :label="$t('base_languageKey_param_dialog.suo_shu_fen_zu')" prop="parentId">
              <custom-select
                v-model="form.parentId"
                :placeholder="$t('Common.com_please_select')"
                :props="{
                  label: 'name',
                  value: 'id',
                  checkStrictly: true,
                  emitPath: false,
                }"
                type="tree"
                url="LanguageKeyGroupTree"
                :show-all-levels="false"
                :listener="form.langKeyType"
                :params="{ appId: form.appId, langKeyType: form.langKeyType }"
              ></custom-select>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item :label="$t('base_languageKey_param_dialog.jian_ming_cheng')" prop="langKeyName">
              <el-input v-model="form.langKeyName"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item :label="$t('base_languageKey_param_dialog.jian_dai_ma')" prop="langKeyCode">
              <el-input v-model="form.langKeyCode"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item :label="$t('base_languageKey_param_dialog.mo_ren_zhi')" prop="defaultValue">
              <el-input v-model="form.defaultValue"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item :label="$t('base_languageKey_param_dialog.xian_shi_shun_xu')" prop="showOrder">
              <el-input type="number" :min="0" v-model.number="form.showOrder"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item :label="$t('base_languageKey_param_dialog.jian_miao_shu')" prop="langKeyDesc">
              <el-input :rows="3" type="textarea" v-model="form.langKeyDesc"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button @click="visible = false">{{ $t('Common.com_cancel') }}</el-button>
      <el-button type="primary" @click="keepAddingLangConfig" v-if="model.type === 'add'">{{ $t('base_languageKey_param_dialog.ji_xu_tian_jia') }}</el-button>
      <el-button type="primary" @click="saveLangConfig">{{ $t('Common.com_confirm') }}</el-button>
    </div>
  </custom-dialog>
</template>

<script>
import apis from '@/utils/apis';
import dialogMixins from '@/mixins/dialog_mixins.js';

export default {
  mixins: [dialogMixins],
  data() {
    return {
      form: {
        langKeyId: '',
        appId: '',
        parentId: null,
        langKeyType: '',
        langKeyName: '',
        langKeyCode: '',
        defaultValue: '',
        showOrder: 0,
        langKeyDesc: '',
      },
      // 用于展示的表单值
      appName: '',
      parentName: '',
    };
  },
  computed: {
    rules() {
      return {
        appId: {
          required: true,
          message: this.$t('Common.com_required'),
        },
        langKeyType: {
          required: true,
          message: this.$t('base_languageKey_param_dialog.qtxssjlx'),
        },
        parentId: {
          required: true,
          message: this.$t('base_languageKey_param_dialog.ssfzbx'),
        },
        langKeyName: [
          {
            required: true,
            message: this.$t('base_languageKey_param_dialog.jmcbt'),
          },
          { max: 100, message: this.$t('Common.com_rules_length_max', [100]), },
        ],
        langKeyCode: [
          {
            required: true,
            message: this.$t('base_languageKey_param_dialog.jian_dai_ma_bi_tian'),
          },
          { max: 100, message: this.$t('Common.com_rules_length_max', [100]), },
        ],
        showOrder: {
          type: 'number',
          min: 0,
          message: this.$t('Common.com_rules_number_min', [0]),
        },
        defaultValue: [
          {
            required: true,
            message: this.$t('base_languageKey_param_dialog.mo_ren_zhi_bi_tian'),
          },
          { max: 100, message: this.$t('Common.com_rules_length_max', [100]), },
        ],
        langKeyDesc: { max: 100, message: this.$t('Common.com_rules_length_max', [100]), },
      };
    },
  },
  mounted() {
    this.initDialog();
  },
  methods: {
    // 初始化
    initDialog: function () {
      if (this.model.type === 'edit') {
        this.appName = this.model.data.appName;
        this.$setFormatData(this.form, this.model.data.row);
        this.form.langKeyType = `${this.model.data.row.langKeyType}`;
      } else if (this.model.type === 'add') {
        this.appName = this.model.data.appName;
        this.form.appId = this.model.data.appId;
        this.form.parentId = this.model.data.parentId;
        this.form.langKeyType = `${this.model.data.langKeyType}`;
        if (this.form.langKeyType === '4') {
          this.form.langKeyType = '5';
        }
      }
    },
    // 确认保存
    saveLangConfig: function () {
      this.$refs.form.validate((valid) => {
        if (!valid) {
          return;
        }
        if (this.model.type === 'edit') {
          this.saveEditLangConfig();
        } else if (this.model.type === 'add') {
          this.saveAddLangConfig();
        }
      });
    },
    // 继续添加
    keepAddingLangConfig: function () {
      this.$refs.form.validate((valid) => {
        if (!valid) {
          return;
        }
        this.$postJSON(apis.LanguageKeyLangAdd, this.form).then(() => {
          this.$message({
            message: this.$t('Common.com_add_success'),
            type: 'success',
          });
          // 重置
          this.form.langKeyName = '';
          this.form.langKeyCode = '';
          this.form.defaultValue = '';
          this.form.langKeyDesc = '';
          this.$refs.form.resetFields();
          this.$emit('success');
        });
      });
    },
    // 新增
    saveAddLangConfig: function () {
      this.$postJSON(apis.LanguageKeyLangAdd, this.form).then(() => {
        this.$message({
          message: this.$t('Common.com_add_success'),
          type: 'success',
        });
        this.$emit('success');
        this.visible = false;
      });
    },
    // 保存编辑分组
    saveEditLangConfig: function () {
      this.$postJSON(apis.LanguageKeyLangUpdate, this.form).then(() => {
        this.$message({
          message: this.$t('Common.com_edit_success'),
          type: 'success',
        });
        this.$emit('success');
        this.visible = false;
      });
    },
  },
};
</script>

<style lang="scss"></style>
